import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import api from './services/api';

const firebaseConfig = {
  apiKey: 'AIzaSyBs-Ah3sjrBIlMWff4tFDNCc2GOriObBLY',
  authDomain: 'nuzlio.firebaseapp.com',
  projectId: 'nuzlio',
  storageBucket: 'nuzlio.appspot.com',
  messagingSenderId: '883626340364',
  appId: '1:883626340364:web:09c794279d398e0edd7e29',
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const VAPID_KEY = 'BCZFbvpf7L2UjpWCaOVDK-FfWiOfQe1HiiM7XYWciFDNiel5I6hJPvE30t7Qxn0eQYCeU1rC6eTpo2VwAabC-KE';

export const requestNotificationPermission = async () => {
  try {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (!token) return;
    await api.post('/fcm/token', { token });
    console.log('FCM token saved');
  } catch (err) {
    console.error('FCM setup error:', err.message);
  }
};

export { onMessage };
